export const CA_EVENT_TYPES = {
    PAGE_VIEW: "page_view",
    PHONE_NUMBER_DISPLAY: "phone_number_display",
    CONTACT_FORM_SUBMIT: "contact_form_submit",
};
